import moment from 'moment/moment';
import { round } from 'lodash';

export default function minuteDuration(timeplanUnit) {
  const mFrom = moment(`${timeplanUnit.date} ${timeplanUnit.from}`, 'YYYY-MM-DD HH:mm');
  const mTo = moment(`${timeplanUnit.date} ${timeplanUnit.to}`, 'YYYY-MM-DD HH:mm');
  return round(((mTo.diff(mFrom, 'minute') || 0)), 2);
}
